import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { formatDate, formatMontant } from '../utils/helpers';

function CopyBtn({ text }) {
  const [ok, setOk] = useState(false);
  if (!text || text === '—') return null;
  return (
    <button onClick={e => { e.stopPropagation(); navigator.clipboard.writeText(text).then(() => { setOk(true); setTimeout(() => setOk(false), 1500); }); }}
      style={{ background:'none', border:'none', cursor:'pointer', padding:'0 3px', color: ok ? '#4caf50' : '#bbb', fontSize:13, flexShrink:0, lineHeight:1 }} title="Copier">
      {ok ? '✓' : '⧉'}
    </button>
  );
}

const EJS_SERVICE   = process.env.REACT_APP_EMAILJS_SERVICE_ID           || '';
const EJS_VALID_DS  = process.env.REACT_APP_EMAILJS_TEMPLATE_VALID_DS     || '';
const EJS_BIENVENU  = process.env.REACT_APP_EMAILJS_TEMPLATE_BIENVENUE    || '';
const EJS_REFUS     = process.env.REACT_APP_EMAILJS_TEMPLATE_REFUS        || '';
const EJS_COMPLEMENT= process.env.REACT_APP_EMAILJS_TEMPLATE_COMPLEMENT   || '';
const EJS_KEY       = process.env.REACT_APP_EMAILJS_PUBLIC_KEY             || '';

function sendEmail(templateId, params) {
  if (!templateId || !EJS_SERVICE || !EJS_KEY || !params.to_email) return;
  emailjs.send(EJS_SERVICE, templateId, params, EJS_KEY).catch(() => {});
}

const STATUT_LABELS = { en_attente:'En attente', valide:'Validé', refuse:'Refusé', complement:'Complément demandé' };
const TYPE_LABELS = { adhesion:'Adhésion', arret_adhesion:'Arrêt adhésion', changement_rib:'Changement RIB', bascule_prelevement:'Bascule prélèvement' };
const TYPE_ICONS = { adhesion:'➕', arret_adhesion:'🛑', changement_rib:'🏦', bascule_prelevement:'🔄' };
const STATUT_CLASS = { en_attente:'demande-statut-attente', valide:'demande-statut-valide', refuse:'demande-statut-refuse', complement:'demande-statut-complement' };

export default function ValidationAdhesions({ demandes, etablissements, validateDemande, recreerAdherentDemande, rejectDemande, askComplement, deleteDemande, currentRole, users, adherents }) {
  const [selected, setSelected] = useState(null);
  const [actionModal, setActionModal] = useState(null); // { type: 'refuse'|'complement', id }
  const [actionText, setActionText] = useState('');
  const [filterStatut, setFilterStatut] = useState('en_attente');
  const [validating, setValidating] = useState(false);

  const etabName = id => etablissements.find(e => e.id === id)?.nom || '—';

  const filtered = (demandes || []).filter(d => !filterStatut || d.statut === filterStatut);
  const pendingCount = (demandes || []).filter(d => d.statut === 'en_attente').length;
  const getType = d => d.type || 'adhesion';
  const dem = selected ? (demandes || []).find(d => d.id === selected) : null;

  const getDsEmail = (username) => (users || []).find(u => u.username === username)?.email || '';

  const handleValidate = (d) => {
    if (validating) return;
    setValidating(true);
    validateDemande(d.id);
    setSelected(null);
    setTimeout(() => setValidating(false), 2000);
    if (d.type === 'adhesion' || !d.type) {
      const dsEmail = getDsEmail(d.createdBy);
      sendEmail(EJS_VALID_DS, {
        to_email: dsEmail,
        delegue_name: d.createdBy || 'Délégué',
        adherent_prenom: d.prenom,
        adherent_nom: d.nom,
      });
      if (d.email) {
        sendEmail(EJS_BIENVENU, {
          to_email: d.email,
          prenom: d.prenom,
          nom: d.nom,
        });
      }
    }
  };

  const handleAction = () => {
    if (!actionModal) return;
    const d = (demandes || []).find(x => x.id === actionModal.id);
    if (actionModal.type === 'refuse') {
      rejectDemande(actionModal.id, actionText);
      if (d) {
        const dsEmail = getDsEmail(d.createdBy);
        const prenom = d.type === 'adhesion' || !d.type ? d.prenom : d.adherentPrenom;
        const nom = d.type === 'adhesion' || !d.type ? d.nom : d.adherentNom;
        sendEmail(EJS_REFUS, {
          to_email: dsEmail,
          delegue_name: d.createdBy || 'Délégué',
          adherent_prenom: prenom,
          adherent_nom: nom,
          motif: actionText,
        });
      }
    }
    if (actionModal.type === 'complement') {
      askComplement(actionModal.id, actionText);
      if (d) {
        const dsEmail = getDsEmail(d.createdBy);
        const prenom = d.type === 'adhesion' || !d.type ? d.prenom : d.adherentPrenom;
        const nom = d.type === 'adhesion' || !d.type ? d.nom : d.adherentNom;
        sendEmail(EJS_COMPLEMENT, {
          to_email: dsEmail,
          delegue_name: d.createdBy || 'Délégué',
          adherent_prenom: prenom,
          adherent_nom: nom,
          message_complement: actionText,
          instruction: 'Connectez-vous sur votre espace délégué (SDASSP FO Réunion) pour soumettre les compléments demandés. Ne répondez pas à cet e-mail.',
        });
      }
    }
    setActionModal(null); setActionText(''); setSelected(null);
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">✅ Validations des adhésions</div>
          <div className="page-subtitle">
            {pendingCount > 0 ? <span style={{ color:'#CC0000', fontWeight:600 }}>{pendingCount} demande{pendingCount>1?'s':''} en attente</span> : 'Aucune demande en attente'}
          </div>
        </div>
      </div>

      {pendingCount > 0 && (
        <div className="alert alert-warning mb-4">
          <span>🔔</span>
          <div><strong>{pendingCount} nouvelle{pendingCount>1?'s':''} adhésion{pendingCount>1?'s':''}</strong> à traiter. Cliquez sur une demande pour la valider, demander un complément ou la refuser.</div>
        </div>
      )}

      <div className="flex gap-2 mb-4">
        {[['','Toutes'],['en_attente','En attente'],['valide','Validées'],['refuse','Refusées'],['complement','Complément']].map(([v,l]) => (
          <button key={v} className={`btn btn-sm ${filterStatut===v?'btn-primary':'btn-outline'}`} onClick={() => setFilterStatut(v)}>
            {l} {v==='en_attente'&&pendingCount>0?`(${pendingCount})`:''}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="empty-state"><div className="empty-state-icon">📋</div><div className="empty-state-text">Aucune demande dans cette catégorie.</div></div>
      ) : (
        <div style={{ display:'grid', gridTemplateColumns: dem ? '1fr 1fr' : '1fr', gap:16, alignItems:'start' }}>
          {/* List */}
          <div>
            {filtered.map(d => (
              <div key={d.id} className="demande-card" style={{ cursor:'pointer', border: selected===d.id ? '2px solid #CC0000' : undefined }} onClick={() => setSelected(selected===d.id?null:d.id)}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:40, height:40, background: getType(d)==='arret_adhesion'?'#c62828':getType(d)==='changement_rib'?'#1565c0':getType(d)==='bascule_prelevement'?'#2e7d32':'#CC0000', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:18, flexShrink:0 }}>
                    {TYPE_ICONS[getType(d)]}
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontWeight:700, fontSize:14 }}>
                      {getType(d) !== 'adhesion' ? `${d.adherentPrenom} ${d.adherentNom}` : `${d.prenom} ${d.nom}`}
                    </div>
                    <div style={{ fontSize:12, color:'#888' }}>{TYPE_LABELS[getType(d)]} · {formatDate(d.dateCreation)}</div>
                    {getType(d) === 'adhesion' && <div style={{ fontSize:11, color:'#aaa' }}>{d.metier||'—'} · {etabName(d.etablissementId)}</div>}
                  </div>
                  <div style={{ textAlign:'right', flexShrink:0 }}>
                    <span className={STATUT_CLASS[d.statut]}>{STATUT_LABELS[d.statut]}</span>
                    {d.montant && getType(d)==='adhesion' && <div style={{ fontSize:13, fontWeight:600, color:'#CC0000', marginTop:4 }}>{d.montant} €/{d.periodicite?.toLowerCase()?.slice(0,3)||'mois'}</div>}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Detail panel */}
          {dem && (
            <div className="card" style={{ position:'sticky', top:70 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:16 }}>
                <div>
                  <div style={{ fontWeight:700, fontSize:16 }}>{TYPE_ICONS[getType(dem)]} {getType(dem) !== 'adhesion' ? `${dem.adherentPrenom} ${dem.adherentNom}` : `${dem.prenom} ${dem.nom}`}</div>
                  <div style={{ fontSize:12, color:'#888', marginTop:2 }}>{TYPE_LABELS[getType(dem)]}</div>
                </div>
                <button className="btn-icon" onClick={() => setSelected(null)}>✕</button>
              </div>
              <span className={STATUT_CLASS[dem.statut]}>{STATUT_LABELS[dem.statut]}</span>

              <div className="divider" />

              {getType(dem) === 'arret_adhesion' ? (
                <div>
                  <div style={{ display:'flex', gap:10, padding:'5px 0', borderBottom:'1px solid #f5f5f5', fontSize:13 }}>
                    <div style={{ width:140, flexShrink:0, color:'#888', fontSize:12, fontWeight:600 }}>Demandé par</div>
                    <div>{dem.createdBy || '—'}</div>
                  </div>
                  <div style={{ display:'flex', gap:10, padding:'5px 0', fontSize:13 }}>
                    <div style={{ width:140, flexShrink:0, color:'#888', fontSize:12, fontWeight:600 }}>Motif</div>
                    <div style={{ color:'#555' }}>{dem.motif || '—'}</div>
                  </div>
                </div>
              ) : getType(dem) === 'changement_rib' ? (
                <div>
                  {[['Nouveau IBAN', dem.newIban||'—'],['Nouveau BIC', dem.newBic||'—'],['Motif', dem.motif||'—'],['Demandé par', dem.createdBy||'—']].map(([l,v]) => (
                    <div key={l} style={{ display:'flex', gap:10, padding:'5px 0', borderBottom:'1px solid #f5f5f5', fontSize:13, alignItems:'center' }}>
                      <div style={{ width:140, flexShrink:0, color:'#888', fontSize:12, fontWeight:600 }}>{l}</div>
                      <code style={{ fontSize:12, flex:1 }}>{v}</code>
                      <CopyBtn text={v} />
                    </div>
                  ))}
                </div>
              ) : getType(dem) === 'bascule_prelevement' ? (
                <div>
                  <div style={{ fontSize:12, color:'#888', marginBottom:8 }}>Mode actuel : <strong>{dem.modePaiementActuel||'—'}</strong></div>
                  {[['RUM', dem.rum||'—'],['Nouveau IBAN', dem.newIban||'—'],['Nouveau BIC', dem.newBic||'—'],['Titulaire', dem.titulaire||'—'],['Jour prélèv.', dem.jourPrelevement ? `${dem.jourPrelevement} du mois` : '—'],['Périodicité', dem.periodicite||'—'],['Demandé par', dem.createdBy||'—']].map(([l,v]) => (
                    <div key={l} style={{ display:'flex', gap:10, padding:'5px 0', borderBottom:'1px solid #f5f5f5', fontSize:13, alignItems:'center' }}>
                      <div style={{ width:140, flexShrink:0, color:'#888', fontSize:12, fontWeight:600 }}>{l}</div>
                      <code style={{ fontSize:12, flex:1 }}>{v}</code>
                      <CopyBtn text={v} />
                    </div>
                  ))}
                  {dem.sepaDocument && (
                    <div style={{ marginTop:8, padding:'8px 10px', background:'#e8f5e9', borderRadius:6, fontSize:13 }}>
                      📎 Mandat SEPA joint
                      <a href={dem.sepaDocument.url || dem.sepaDocument.data} download={dem.sepaDocument.nom} target="_blank" rel="noreferrer" className="btn btn-outline btn-sm" style={{ marginLeft:10 }}>⬇️ Télécharger</a>
                    </div>
                  )}
                </div>
              ) : (
                [['Établissement', etabName(dem.etablissementId) || dem.etablissementLibre || '—'],
                ['Métier', dem.metier||'—'],['Contrat', dem.contrat||'—'],['Convention', dem.convention||'—'],
                ['Téléphone', dem.telephone||'—'],['Email', dem.email||'—'],
                ['Adresse', [dem.adresse, dem.codePostal, dem.ville].filter(Boolean).join(', ')||'—'],
                ['Mode paiement', dem.modePaiement||'—'],['Périodicité', dem.periodicite||'—'],
                ['Montant/échéance', dem.montant ? `${dem.montant} €` : '—'],
                ['Jour prélèvement', dem.jourPrelevement ? `${dem.jourPrelevement} du mois` : '—'],
                ].map(([l,v]) => (
                  <div key={l} style={{ display:'flex', gap:10, padding:'5px 0', borderBottom:'1px solid #f5f5f5', fontSize:13, alignItems:'center' }}>
                    <div style={{ width:140, flexShrink:0, color:'#888', fontSize:12, fontWeight:600 }}>{l}</div>
                    <div style={{ flex:1 }}>{v}</div>
                    <CopyBtn text={v} />
                  </div>
                ))
              )}

              {/* Sensitive banking data — tresorier only */}
              {currentRole === 'tresorier' && (
                <>
                  <div className="divider" />
                  <div style={{ fontSize:12, fontWeight:700, color:'#CC0000', marginBottom:8 }}>🏦 Données bancaires (accès Admin)</div>
                  {[['RUM', dem.rum||'—'],['Titulaire', dem.titulaireCompte||'—'],['Banque', dem.banque||'—'],['IBAN', dem.iban||'—'],['BIC', dem.bic||'—']].map(([l,v]) => (
                    <div key={l} style={{ display:'flex', gap:10, padding:'5px 0', borderBottom:'1px solid #f5f5f5', fontSize:13, alignItems:'center' }}>
                      <div style={{ width:140, flexShrink:0, color:'#888', fontSize:12, fontWeight:600 }}>{l}</div>
                      <code style={{ fontSize:12, flex:1 }}>{v}</code>
                      <CopyBtn text={v} />
                    </div>
                  ))}
                </>
              )}

              {dem.document && (
                <>
                  <div className="divider" />
                  <div style={{ fontSize:12, fontWeight:700, marginBottom:8 }}>📎 Document joint</div>
                  {(() => { const src = typeof dem.document === 'string' ? dem.document : (dem.document?.url || dem.document?.data || ''); const isImg = src.match(/^data:image\//i) || dem.document?.type?.startsWith('image/'); return isImg ? (<img src={src} alt="Document" style={{ width:'100%', maxHeight:200, objectFit:'contain', borderRadius:6, border:'1px solid #eee' }} />) : (<a href={src} download={dem.document?.name || 'document'} target="_blank" rel="noreferrer" className="btn btn-outline btn-sm">⬇️ Télécharger</a>); })()}
                </>
              )}

              {dem.notesDelegue && (
                <>
                  <div className="divider" />
                  <div style={{ fontSize:12, fontWeight:700, marginBottom:4 }}>Notes du délégué</div>
                  <div style={{ fontSize:13, color:'#555', background:'#f9f9f9', padding:'8px 10px', borderRadius:6 }}>{dem.notesDelegue}</div>
                </>
              )}

              {dem.messageComplement && (
                <div className="alert alert-info mt-3">
                  <span>💬</span>
                  <div><strong>Complément demandé :</strong> {dem.messageComplement}</div>
                </div>
              )}
              {dem.complementResponse && (
                <div style={{ background:'#e8f5e9', border:'1px solid #a5d6a7', borderRadius:8, padding:'10px 14px', marginTop:8 }}>
                  <div style={{ fontSize:12, fontWeight:700, color:'#2e7d32', marginBottom:4 }}>✅ Réponse du délégué</div>
                  <div style={{ fontSize:13, color:'#333' }}>{dem.complementResponse}</div>
                  {dem.complementDocument && (
                    <div style={{ marginTop:8 }}>
                      {dem.complementDocument.type?.startsWith('image/') ? (
                        <img src={dem.complementDocument.data} alt="Document" style={{ width:'100%', maxHeight:180, objectFit:'contain', borderRadius:6, border:'1px solid #c8e6c9' }} />
                      ) : (
                        <a href={dem.complementDocument.data} download={dem.complementDocument.nom} className="btn btn-outline btn-sm" style={{ borderColor:'#a5d6a7', color:'#2e7d32' }}>
                          ⬇️ {dem.complementDocument.nom}
                        </a>
                      )}
                    </div>
                  )}
                  {dem.dateComplementResponse && <div style={{ fontSize:11, color:'#888', marginTop:6 }}>{new Date(dem.dateComplementResponse).toLocaleDateString('fr-FR')}</div>}
                </div>
              )}
              {dem.motifRefus && (
                <div className="alert alert-danger mt-3">
                  <span>✕</span>
                  <div><strong>Motif de refus :</strong> {dem.motifRefus}</div>
                </div>
              )}

              {['refuse','complement'].includes(dem.statut) && currentRole === 'tresorier' && (
                <div style={{ marginTop:12 }}>
                  <button
                    className="btn btn-sm"
                    style={{ color:'#c62828', borderColor:'#ef9a9a', border:'1px solid', background:'#fff', width:'100%', padding:'7px' }}
                    onClick={() => { if (window.confirm('Supprimer définitivement cette demande ?')) { deleteDemande(dem.id); setSelected(null); } }}
                  >
                    🗑️ Supprimer cette demande
                  </button>
                </div>
              )}
              {dem.statut === 'valide' && (getType(dem) === 'adhesion') && currentRole === 'tresorier' && (
                <div style={{ marginTop:12 }}>
                  <button
                    className="btn btn-sm"
                    style={{ background:'#eff6ff', color:'#1d4ed8', border:'1px solid #bfdbfe', width:'100%', padding:'7px', fontWeight:600 }}
                    onClick={() => { recreerAdherentDemande(dem.id); setSelected(null); }}
                  >
                    🔄 Recréer la fiche adhérent (fiche perdue)
                  </button>
                </div>
              )}
              {(['en_attente', 'complement'].includes(dem.statut)) && currentRole === 'tresorier' && (
                <div style={{ display:'flex', gap:8, marginTop:16, flexWrap:'wrap' }}>
                  {getType(dem) === 'arret_adhesion' && (
                    <button className="btn btn-success" style={{ flex:1, background:'#c62828' }} onClick={() => handleValidate(dem)} disabled={validating}>
                      🛑 Valider — radier l'adhérent
                    </button>
                  )}
                  {getType(dem) === 'changement_rib' && (
                    <button className="btn btn-success" style={{ flex:1 }} onClick={() => handleValidate(dem)} disabled={validating}>
                      🏦 Valider — mettre à jour RIB
                    </button>
                  )}
                  {getType(dem) === 'adhesion' && (
                    <button className="btn btn-success" style={{ flex:1 }} onClick={() => handleValidate(dem)} disabled={validating}>
                      ✅ Valider — créer la fiche adhérent
                    </button>
                  )}
                  {dem.statut === 'en_attente' && (
                    <button className="btn btn-outline btn-sm" onClick={() => { setActionModal({ type:'complement', id:dem.id }); setActionText(''); }}>
                      💬 Demander complément
                    </button>
                  )}
                  <button className="btn btn-outline btn-sm" style={{ color:'#c62828', borderColor:'#ef9a9a' }} onClick={() => { setActionModal({ type:'refuse', id:dem.id }); setActionText(''); }}>
                    ✕ Refuser
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* Action modal */}
      {actionModal && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth:440 }}>
            <div className="modal-header">
              <span className="modal-title">{actionModal.type === 'refuse' ? '✕ Refuser la demande' : '💬 Demander un complément'}</span>
              <button className="btn-icon" onClick={() => setActionModal(null)}>✕</button>
            </div>
            <div className="form-group">
              <label className="form-label">{actionModal.type === 'refuse' ? 'Motif de refus *' : 'Message au délégué *'}</label>
              <textarea className="form-control" value={actionText} onChange={e => setActionText(e.target.value)} rows={4}
                placeholder={actionModal.type === 'refuse' ? 'Ex : Document illisible, informations incomplètes...' : 'Ex : Merci de fournir le mandat SEPA signé en original...'} />
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline" onClick={() => setActionModal(null)}>Annuler</button>
              <button className="btn btn-primary" onClick={handleAction} disabled={!actionText.trim()}>Confirmer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
